import './clients-columns.scss';

import { type ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import { formatPhoneNumber } from '@/services/formatter';
import { getUserFullName } from '@/services/helpers/strings';

import type { TClient } from '../../../types';

const clientsColumns: ColumnsType<TClient> = [
  {
    title: 'Клиент',
    dataIndex: 'clientFullName',
    key: 'clientFullName',
    width: 200,
    render: (_, record) => {
      return (
        <div className="clients-columns__cell clients-columns__cell-text">
          <div className="clients-columns__avatar">
            {record?.firstName[0] || ''}
          </div>
          <p>{getUserFullName(record)}</p>
        </div>
      );
    }
  },
  {
    title: 'ИИН',
    dataIndex: 'clientIin',
    key: 'clientIin',
    width: 130,
    render: (_, record) => {
      return (
        <p className="clients-columns__cell-text clients-columns__cell-text--font-medium">
          {record?.clientIin || '—'}
        </p>
      );
    }
  },
  {
    title: 'Номер телефона',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    width: 130,
    render: (_, record) => {
      return (
        <p className="clients-columns__cell-text clients-columns__cell-text--font-medium">
          {formatPhoneNumber(record?.phoneNumber, '—')}
        </p>
      );
    }
  },
  {
    title: 'Дата создания клиента',
    dataIndex: 'createDate',
    key: 'createDate',
    width: 130,
    render: (_, record) => {
      return (
        <p className="clients-columns__cell-text">
          {dayjs(record?.createDate).isValid()
            ? dayjs(record?.createDate).format('DD.MM.YYYY')
            : '—'}
        </p>
      );
    }
  },
  {
    title: 'Дата последней заявки',
    dataIndex: 'lastRequestCreationDate',
    key: 'lastRequestCreationDate',
    width: 130,
    render: (_, record) => {
      return (
        <p className="clients-columns__cell-text">
          {dayjs(record?.lastRequestCreationDate).isValid()
            ? dayjs(record?.lastRequestCreationDate).format('DD.MM.YYYY, HH:mm')
            : '—'}
        </p>
      );
    }
  }
];

export default clientsColumns;
